import { IOrderDetail } from 'core/model/interfaces/orders';
import { apiService } from 'core/services';
import { IGetOrderRequest } from 'core/services/orders/orders.dto';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../orders.constants';
import { IOrdersState } from '../orders.type';

export const fetchOrderById = createAppAsyncThunk<IOrderDetail, IGetOrderRequest>(
  `${SLICE_NAMESPACE}/fetchOrderById`,
  async data => {
    try {
      return await apiService.orders.getOderDetail(data);
    } catch (error) {
      notificationService.global.error(handleErrorMessage(error, 'Falló al obtener el detalle del pedido.'));
      throw error;
    }
  },
);

export const fetchOrderByIdReducer: TSliceExtraReducer<IOrdersState> = builder =>
  builder
    .addCase(fetchOrderById.pending, state => {
      state.orderDetail.isLoading = true;
    })
    .addCase(fetchOrderById.fulfilled, (state, action) => {
      state.orderDetail.data = action.payload;
      state.orderDetail.isLoading = false;
      state.orderDetail.isSuccess = true;
    })
    .addCase(fetchOrderById.rejected, (state, action) => {
      state.orderDetail.isLoading = false;
      state.orderDetail.isSuccess = false;
      state.orderDetail.error = action.error.message ?? '';
      state.orderDetail.data = null;
    });
